import MainLayout from './MainLayout'

export default MainLayout



// WEBPACK FOOTER //
// ./src/components/MainLayout/index.js